export default __webpack_public_path__ + "static/dev-b4b10a4d3925e4516d57f10db41d71c3.png";